/**
 * Lighting setup for the 3D scene
 */

import type * as THREE_NS from 'three';

export function setupLighting(scene: THREE_NS.Scene, THREE: typeof THREE_NS): void {
  const {
    AmbientLight,
    DirectionalLight,
    RectAreaLight,
    PointLight,
    SpotLight,
    HemisphereLight,
    Color,
  } = THREE as any;

  const ambientLight = new AmbientLight(0xffffff, 2.0);
  scene.add(ambientLight);

  const directionalLight = new DirectionalLight(0xffffff, 5.0);
  directionalLight.position.set(15, 20, 15);
  directionalLight.castShadow = true;
  directionalLight.shadow.mapSize.width = 2048;
  directionalLight.shadow.mapSize.height = 2048;
  scene.add(directionalLight);

  const rectAreaLight1 = new RectAreaLight(0xffffff, 8.0, 10, 10);
  rectAreaLight1.position.set(20, 10, 0);
  rectAreaLight1.lookAt(0, 0, 0);
  scene.add(rectAreaLight1);

  const rectAreaLight2 = new RectAreaLight(0xffaaff, 6.0, 8, 8);
  rectAreaLight2.position.set(-20, -10, 0);
  rectAreaLight2.lookAt(0, 0, 0);
  scene.add(rectAreaLight2);

  const rectAreaLight3 = new RectAreaLight(0xaaffff, 7.0, 12, 6);
  rectAreaLight3.position.set(0, 0, 25);
  rectAreaLight3.lookAt(0, 0, 0);
  scene.add(rectAreaLight3);

  const pointLight1 = new PointLight(0xffffff, 8.0, 100);
  pointLight1.position.set(-15, 5, 15);
  scene.add(pointLight1);

  const pointLight2 = new PointLight(0x88aaff, 6.0, 80);
  pointLight2.position.set(20, -5, -20);
  scene.add(pointLight2);

  const pointLight3 = new PointLight(0xffaa88, 7.0, 60);
  pointLight3.position.set(0, 0, -25);
  scene.add(pointLight3);

  const pointLight4 = new PointLight(0xaaff88, 5.0, 70);
  pointLight4.position.set(0, -15, 0);
  scene.add(pointLight4);

  const spotLight1 = new SpotLight(0xffffff, 10.0, 100, Math.PI / 6, 0.3, 1);
  spotLight1.position.set(25, 25, 25);
  spotLight1.target.position.set(0, 0, 0);
  spotLight1.castShadow = true;
  scene.add(spotLight1);
  scene.add(spotLight1.target);

  const spotLight2 = new SpotLight(0xffaaff, 8.0, 80, Math.PI / 8, 0.2, 1);
  spotLight2.position.set(-25, -25, -25);
  spotLight2.target.position.set(0, 0, 0);
  spotLight2.castShadow = true;
  scene.add(spotLight2);
  scene.add(spotLight2.target);

  const hemisphereLight = new HemisphereLight(new Color(0x87ceeb), new Color(0x8b4513), 4.0);
  hemisphereLight.position.set(0, 20, 0);
  scene.add(hemisphereLight);
}
